<template>
  <div id="innerContent" class="mx-5">
    <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
      <Loading />
    </div>
    <div v-else class="form-row w-100 d-flex align-items-end justify-content-end">
      <div>
        <button v-b-modal.new-office class="btn btn-primary">
          <b-icon-plus></b-icon-plus>
          New Office
        </button>
      </div>
      <div class="col-auto mb-1">
        <b-modal
          id="new-office"
          ref="modal"
          @show="resetModal"
          @hidden="resetModal"
          @shown="initFormlessFloatingLabels()"
          @ok="addOffice"
        >
          <template v-slot:modal-title>
            Add Office
          </template>
          <template v-slot:default>
            <div v-if="error" class="d-flex align-items-center justify-content-center">
              <div style="max-width: 400px;">
                <h6 class="text-2xl text-red-500 font-weight-bold">
                  An error has occured
                </h6>
              </div>
            </div>
            <form ref="office" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Office"
                label-for="office-input"
                :state="officeState.nameState"
              >
                <b-form-input
                  id="office-input"
                  v-model="office.name"
                  :state="officeState.nameState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="address" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Address"
                label-for="address-input"
                :state="officeState.addressState"
              >
                <b-form-input
                  id="address-input"
                  v-model="office.address"
                  :state="officeState.addressState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="country" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Country"
                label-for="country-input"
                :state="officeState.countryState"
              >
                <!-- <b-form-input
                  id="country-input"
                  v-model="office.country"
                  :state="officeState.countryState"
                  required
                ></b-form-input> -->
                <country-select class="form-control text-center"
                required
                id="country-input"
                countryName="true"
                placeholder=""
                v-model="office.country" :country="office.country"
                :state="officeState.countryState"
                topCountry="US" />
              </b-form-group>
            </form>

            <b-row>
              <b-col class="floating-label-container">
                <form ref="city" @submit.stop.prevent="addOffice">
                  <b-form-group
                    label="City"
                    label-for="city-input"
                    :state="officeState.cityState"
                  >
                    <b-form-input
                      id="city-input"
                      v-model="office.city"
                      :state="officeState.cityState"
                      required
                    ></b-form-input>
                  </b-form-group>
                </form>
              </b-col>
              <b-col class="floating-label-container">
                <form ref="state" @submit.stop.prevent="addOffice">
                  <b-form-group
                    label="State"
                    label-for="state-input"
                    :state="officeState.stateState"
                  >
                    <b-form-input
                      id="city-input"
                      v-model="office.state"
                      :state="officeState.stateState"
                    ></b-form-input>
                  </b-form-group>
                </form>
              </b-col>
              <b-col class="floating-label-container">
                <form ref="zipCode" @submit.stop.prevent="addOffice">
                  <b-form-group
                    label="ZipCode"
                    label-for="zipCode-input"
                    :state="officeState.zipCodeState"
                  >
                    <b-form-input
                      id="zipCode-input"
                      v-model="office.zipCode"
                      :state="officeState.zipCodeState"
                    ></b-form-input>
                  </b-form-group>
                </form>
              </b-col>
            </b-row>

            <form ref="phone" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Phone"
                label-for="phone-input"
                :state="officeState.phoneState"
              >
                <b-form-input
                  id="phone-input"
                  v-model="office.phone"
                  :state="officeState.phoneState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="airportCode" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Airport Code"
                label-for="airportCode-input"
                :state="officeState.airportCodeState"
              >
                <b-form-input
                  id="airportCode-input"
                  v-model="office.airportCode"
                  :state="officeState.airportCodeState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <label class="font-weight-bold">Certification</label>
            <form ref="iata" @submit.stop.prevent="addOffice">
              <b-form-group
                label="IATA ID Number"
                label-for="iata-input"
                :state="officeState.iataState"
              >
                <b-form-input
                  id="iata-input"
                  v-model="office.iata"
                  :state="officeState.iataState"
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="bond" @submit.stop.prevent="addOffice">
              <b-form-group
                label="Bond ID Number"
                label-for="Bond-input"
                :state="officeState.bondState"
              >
                <b-form-input
                  id="Bond-input"
                  v-model="office.bond"
                  :state="officeState.bondState"
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="fmc" @submit.stop.prevent="addOffice">
              <b-form-group
                label="FMC/OTI Number"
                label-for="fmc-input"
                :state="officeState.fmcState"
              >
                <b-form-input
                  id="fmc-input"
                  v-model="office.fmc"
                  :state="officeState.fmcState"
                ></b-form-input>
              </b-form-group>
            </form>

            <!-- <form ref="shipping" @submit.stop.prevent="addOffice">
              <b-form-group
                label="AES/ITN"
                label-for="shipping-input"
                :state="officeState.shippingState"
              >
                <b-form-input
                  id="shipping-input"
                  v-model="office.shipping"
                  :state="officeState.shippingState"
                ></b-form-input>
              </b-form-group>
            </form> -->

            <form ref="site" @submit.stop.prevent="addOffice">
              <b-form-group
                class="font-weight-bold"
                label="Site Details"
                label-for="site-input"
                :state="officeState.sizeState"
              >
                <b-form-input
                  id="size-input"
                  placeholder="Size"
                  type="number"
                  step="0.01"
                  min="0.0"
                  v-model="office.size"
                  :state="officeState.sizeState"
                ></b-form-input>

                <b-form-checkbox
                  class="font-weight-normal"
                  id="Warehouse"
                  v-model="office.warehouse"
                >
                  Warehouse
                </b-form-checkbox>
              </b-form-group>
            </form>

            <form ref="timezone" @submit.stop.prevent="addOffice">
              <b-form-group
                  label="Timezone"
                  label-for="timezone-input"
                  :state="officeState.timezoneState"
              >
                <b-form-select
                    required
                    v-model="office.timezone"
                    :options="timezoneOptions"
                    :state="officeState.timezoneState"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                ></b-form-select>
              </b-form-group>
            </form>
          </template>
        </b-modal>
      </div>
    </div>
  <hr/>
  <table class="table table-hover" v-cloak>
    <thead>
    <tr>
      <th scope="col">Office
          <button @click="orderByName = !orderByName" class="btn btn-light">
            <div v-if="orderByName">
              <b-icon-arrow-down-short></b-icon-arrow-down-short>
            </div>
            <div v-else>
              <b-icon-arrow-up-short></b-icon-arrow-up-short>
            </div>
          </button>
      </th>
      <th scope="col">Address</th>
      <th scope="col">AirportCode</th>
      <th scope="col">Site Details</th>
      <th scope="col">Certification</th>
      <th scope="col">Timezone</th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(result) in namesOrdered" :key="result.id">
        <!-- <th scope="row">{{ result.id }}</th> -->
        <td>{{ result.name.toUpperCase() }}</td>
        <td>{{ result.address.toUpperCase() }}</td>
        <td>{{ result.airportCode.toUpperCase() }}</td>
        <td>
            SIZE: {{ result.size }}
            <br>
            WAREHOUSE: {{ result.warehouse }}
        </td>
        <td>
            IATA ID #: {{ result.iata }}
            <br>
            BOND ID #: {{ result.bond }}
            <br>
            FMC/OTI #: {{ result.fmc }}
        </td>
        <td>{{ result.timezone }}</td>
        <td>
          <button
          v-b-modal.edit-office @click="selected(result)" class="btn btn-success">
          <b-icon-pencil></b-icon-pencil>
          </button>

         <button
          v-b-modal.delete-office
          @click="selected(result)" class="btn btn-danger">
            <b-icon-trash></b-icon-trash>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <b-modal
    id="edit-office"
    ref="editmodal"
    @show="resetModal"
    @hidden="resetModal"
    @shown="initFormlessFloatingLabels()"
    @ok="edit($event)"
  >
    <template v-slot:modal-title>
      Edit Office
    </template>
    <template v-slot:default>
      <div v-if="error" class="d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
        <h6 class="text-2xl text-red-500 font-weight-bold">
          An error has occured
        </h6>
        </div>
      </div>
      <form ref="office" @submit.stop.prevent="edit">
        <b-form-group
          label="Office"
          label-for="office-input"
          :state="officeState.nameState"
        >
          <b-form-input
            id="office-input"
            v-model="selectedOffice.name"
            :state="officeState.nameState"
            required
          ></b-form-input>
        </b-form-group>
      </form>

      <form ref="address" @submit.stop.prevent="edit">
        <b-form-group
          label="Address"
          label-for="address-input"
          :state="officeState.addressState"
        >
          <b-form-input
            id="address-input"
            v-model="selectedOffice.address"
            :state="officeState.addressState"
            required
          ></b-form-input>
        </b-form-group>
      </form>

      <form ref="country" @submit.stop.prevent="edit">
        <b-form-group
          label="Country"
          label-for="country-input"
          :state="officeState.countryState"
        >
          <!-- <b-form-input
            id="country-input"
            v-model="selectedOffice.country"
            :state="officeState.countryState"
            required
          ></b-form-input> -->
          <country-select class="form-control text-center"
          required
          id="country-input"
          countryName="true"
          placeholder=""
          v-model="selectedOffice.country" :country="selectedOffice.country"
          :state="officeState.countryState"
          topCountry="US" />
        </b-form-group>
      </form>

      <b-row>
        <b-col class="floating-label-container">
          <form ref="city" @submit.stop.prevent="edit">
            <b-form-group
              label="City"
              label-for="city-input"
              :state="officeState.cityState"
            >
              <b-form-input
                id="city-input"
                v-model="selectedOffice.city"
                :state="officeState.cityState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
        </b-col>
        <b-col class="floating-label-container">
          <form ref="state" @submit.stop.prevent="edit">
            <b-form-group
              label="State"
              label-for="state-input"
              :state="officeState.stateState"
            >
              <b-form-input
                id="city-input"
                v-model="selectedOffice.state"
                :state="officeState.stateState"
              ></b-form-input>
            </b-form-group>
          </form>
        </b-col>
        <b-col class="floating-label-container">
          <form ref="zipCode" @submit.stop.prevent="edit">
            <b-form-group
              label="ZipCode"
              label-for="zipCode-input"
              :state="officeState.zipCodeState"
            >
              <b-form-input
                id="zipCode-input"
                v-model="selectedOffice.zipCode"
                :state="officeState.zipCodeState"
              ></b-form-input>
            </b-form-group>
          </form>
        </b-col>
      </b-row>

      <form ref="phone" @submit.stop.prevent="edit">
        <b-form-group
          label="Phone"
          label-for="phone-input"
          :state="officeState.phoneState"
        >
          <b-form-input
            id="phone-input"
            v-model="selectedOffice.phone"
            :state="officeState.phoneState"
            required
          ></b-form-input>
        </b-form-group>
      </form>

      <form ref="airportCode" @submit.stop.prevent="edit">
              <b-form-group
                label="Airport Code"
                label-for="airportCode-input"
                :state="officeState.airportCodeState"
              >
                <b-form-input
                  id="airportCode-input"
                  v-model="selectedOffice.airportCode"
                  :state="officeState.airportCodeState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <label class="font-weight-bold">Certification</label>
            <form ref="iata" @submit.stop.prevent="edit">
              <b-form-group
                label="IATA ID Number"
                label-for="iata-input"
                :state="officeState.iataState"
              >
                <b-form-input
                  id="iata-input"
                  v-model="selectedOffice.iata"
                  :state="officeState.iataState"
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="bond" @submit.stop.prevent="edit">
              <b-form-group
                label="Bond ID Number"
                label-for="Bond-input"
                :state="officeState.bondState"
              >
                <b-form-input
                  id="Bond-input"
                  v-model="selectedOffice.bond"
                  :state="officeState.bondState"
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="fmc" @submit.stop.prevent="edit">
              <b-form-group
                label="FMC/OTI Number"
                label-for="fmc-input"
                :state="officeState.fmcState"
              >
                <b-form-input
                  id="fmc-input"
                  v-model="selectedOffice.fmc"
                  :state="officeState.fmcState"
                ></b-form-input>
              </b-form-group>
            </form>

      <!-- <form ref="shipping" @submit.stop.prevent="edit">
        <b-form-group
          label="AES/ITN"
          label-for="shipping-input"
          :state="officeState.shippingState"
        >
          <b-form-input
            id="shipping-input"
            v-model="selectedOffice.shipping"
            :state="officeState.shippingState"
          ></b-form-input>
        </b-form-group>
      </form> -->

      <form ref="site" @submit.stop.prevent="edit">
        <b-form-group
          class="font-weight-bold"
          label="Site Details"
          label-for="site-input"
          :state="officeState.sizeState"
        >
          <b-form-input
            id="size-input"
            placeholder="Size"
            type="number"
            step="0.01"
            min="0.0"
            v-model="selectedOffice.size"
            :state="officeState.sizeState"
          ></b-form-input>

          <b-form-checkbox
            class="font-weight-normal"
            id="Warehouse"
            v-model="selectedOffice.warehouse"
          >
            Warehouse
          </b-form-checkbox>
        </b-form-group>
      </form>

      <form ref="timezone" @submit.stop.prevent="edit">
        <b-form-group
            label="Timezone"
            label-for="timezone-input"
            :state="officeState.timezoneState"
        >
          <b-form-select
              required
              v-model="selectedOffice.timezone"
              :options="timezoneOptions"
              :state="officeState.timezoneState"
              class="mb-3 normalize-input"
              style=" text-align-last: center; font-size: small;"
          ></b-form-select>
        </b-form-group>
      </form>
    </template>
  </b-modal>

   <b-modal
    id="delete-office"
    ref="deletemodal"
    @show="resetModal"
    @hidden="resetModal"
    @shown="initFormlessFloatingLabels()"
    @ok="remove()"
  >
    <template v-slot:modal-title>
      Delete Confirmation
    </template>
    <template v-slot:default>
      <div>
        <div v-if="error" class="d-flex align-items-center justify-content-center">
          <div style="max-width: 400px;">
            <h6 class="text-2xl text-red-500 font-weight-bold">
              An error has occured
            </h6>
          </div>
        </div>
        <h5 class="font-weight-bold">
          Are you sure you want to delete this Office?
        </h5>
      </div>
    </template>
    <!-- <template #modal-footer="{ ok }">
        <b-button variant="success" @click="ok()">
          OK
        </b-button>
    </template> -->
  </b-modal>
  </div>
</template>

<script>
import { timezoneNames } from '@progress/kendo-date-math';
import '@progress/kendo-date-math/tz/all';
import vueCountryRegionSelect from 'vue-country-region-select';
import Vue from 'vue';
import Loading from '../components/Loading.vue';
import {
  postOffice, getOffice, editOffice, deleteOffice,
} from '../api/admin';

Vue.use(vueCountryRegionSelect);

export default {
  name: 'OfficeSetting',
  data() {
    return {
      tabIndex: 0,
      selectedIndex: -1,
      selectedOffice: {},
      advanced: true,
      loading: true,
      search: '',
      orderByName: true,
      error: false,
      results: [],
      office: {
        name: '',
        address: '',
        country: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        airportCode: '',
        iata: '',
        bond: '',
        fmc: '',
        size: 0,
        warehouse: false,
        timezone: '',
      },
      officeState: {
        nameState: null,
        addressState: null,
        countryState: null,
        cityState: null,
        stateState: null,
        zipCodeState: null,
        phoneState: null,
        airportCodeState: null,
        iataState: null,
        bondState: null,
        fmcState: null,
        sizeState: null,
        timezoneState: null,

      },
      timezoneOptions: [],
    };
  },
  computed: {
    namesOrdered() {
      if (this.orderByName) {
        return this.results.concat().sort((a, b) => a.name.localeCompare(b.name));
      }
      return this.results.concat().sort((a, b) => b.name.localeCompare(a.name));
    },
  },
  methods: {
    initialOfficeState() {
      return {
        name: '',
        address: '',
        country: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        airportCode: '',
        iata: '',
        bond: '',
        fmc: '',
        size: 0,
        warehouse: false,
        timezone: '',
      };
    },
    selected(office) {
      this.selectedOffice = JSON.parse(JSON.stringify(office));
      // this.selectedOffice.timezone = this.selectedOffice.timezone.toUpperCase();
      this.selectedIndex = this.results.findIndex((item) => (this.selectedOffice.id === item.id));
    },
    checkFormValidity() {
      this.officeState.nameState = this.$refs.office.checkValidity();
      this.officeState.addressState = this.$refs.address.checkValidity();
      this.officeState.countryState = this.$refs.country.checkValidity();
      this.officeState.cityState = this.$refs.city.checkValidity();
      this.officeState.stateState = this.$refs.state.checkValidity();
      this.officeState.zipCodeState = this.$refs.zipCode.checkValidity();
      this.officeState.phoneState = this.$refs.phone.checkValidity();
      this.officeState.airportCodeState = this.$refs.airportCode.checkValidity();
      this.officeState.iataState = this.$refs.iata.checkValidity();
      this.officeState.bondState = this.$refs.bond.checkValidity();
      this.officeState.fmcState = this.$refs.fmc.checkValidity();
      this.officeState.sizeState = this.$refs.site.checkValidity();
      this.officeState.timezoneState = this.$refs.timezone.checkValidity();
      let valid = true;
      Object.values(this.officeState).forEach((value) => {
        if (value === false) {
          valid = false;
        }
      });

      return valid;
    },
    editFormValidity() {
      this.officeState.nameState = this.$refs.office[0].checkValidity();
      this.officeState.addressState = this.$refs.address[0].checkValidity();
      this.officeState.countryState = this.$refs.country[0].checkValidity();
      this.officeState.cityState = this.$refs.city[0].checkValidity();
      this.officeState.stateState = this.$refs.state[0].checkValidity();
      this.officeState.zipCodeState = this.$refs.zipCode[0].checkValidity();
      this.officeState.phoneState = this.$refs.phone[0].checkValidity();
      this.officeState.airportCodeState = this.$refs.airportCode[0].checkValidity();
      this.officeState.iataState = this.$refs.iata[0].checkValidity();
      this.officeState.bondState = this.$refs.bond[0].checkValidity();
      this.officeState.fmcState = this.$refs.fmc[0].checkValidity();
      this.officeState.sizeState = this.$refs.site[0].checkValidity();
      this.officeState.timezoneState = this.$refs.timezone[0].checkValidity();
      let valid = true;
      Object.values(this.officeState).forEach((value) => {
        if (value === false) {
          valid = false;
        }
      });

      return valid;
    },
    addOffice(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.checkFormValidity()) {
        return;
      }
      const copy = Object.keys(this.office).reduce((acc, curr) => {
        if (typeof this.office[curr] === 'string' && curr !== 'timezone') {
          acc[curr] = this.office[curr].toLowerCase().trim();
        } else {
          acc[curr] = this.office[curr];
        }
        return acc;
      }, {});

      const data = { data: { ...copy } };
      postOffice(data).then((resp) => {
        console.log('Successfully POSTed');
        this.results.push({ ...copy, id: resp.data.id });
        this.$nextTick(() => {
          this.$bvModal.hide('new-office');
        });
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    edit(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.editFormValidity()) {
        return;
      }
      const copy = Object.keys(this.selectedOffice).reduce((acc, curr) => {
        if (typeof this.selectedOffice[curr] === 'string' && curr !== 'timezone') {
          acc[curr] = this.selectedOffice[curr].toLowerCase().trim();
        } else {
          acc[curr] = this.selectedOffice[curr];
        }
        return acc;
      }, {});

      const data = { data: { ...copy } };
      editOffice(data).then(() => {
        console.log('Successfully POSTed');
        this.$nextTick(() => {
          this.$bvModal.hide('edit-office');
        });
        this.$set(this.results, this.selectedIndex, copy);
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    remove() {
      const data = { data: { ...this.selectedOffice } };
      deleteOffice(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.results = this.results.filter(
          (item) => item.name !== this.selectedOffice.name,
        );
      }).catch((err) => {
        console.log(err);
      });
    },
    resetModal() {
      Object.assign(this.office, this.initialOfficeState());
      Object.keys(this.officeState).forEach((key) => {
        this.officeState[key] = null;
      });
      this.error = false;
    },
    countryFormatter(country) {
      if (!country) {
        return '';
      }
      let arr = [];
      const exludeWords = ['of', 'the', 'and'];
      arr = country.split(' ');
      return arr.map((word, i) => (exludeWords.includes(word) && i !== 0 ? [word] : word.charAt(0).toUpperCase() + word.slice(1))).join(' ');
    },
  },
  mounted() {
    this.timezoneOptions = timezoneNames()
      .filter((l) => l.indexOf('/') > -1)
      .sort((a, b) => a.localeCompare(b));
    getOffice().then((resp) => {
      console.log('Successfully GETed');
      this.results = resp.data.result;
      this.results = this.results.map((office) => ({
        ...office,
        country: this.countryFormatter(office.country),
      }));
      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });
  },
  components: {
    Loading,
  },
};
</script>

<style scoped lang="scss">
</style>
